import type { Me } from "./types";

const titleCase = (s: string) =>
  String(s)
    .split(/[_-]/)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");

export function orgName(companyId: string): string {
  return titleCase(companyId);
}

export function fmtSync(ts?: string | number | null): string {
  const ms = typeof ts === "number" ? ts * 1000 : Date.parse(String(ts ?? ""));
  if (!ms || isNaN(ms)) return "pending";
  return new Date(ms).toLocaleString(undefined, {
    day: "numeric", month: "short", year: "numeric", hour: "numeric", minute: "2-digit",
  });
}

export function displayName(me: Me): string {
  return me.display_name || me.employee_slug;
}

export function displayOrg(me: Me): string {
  return me.org_name || orgName(me.company_id);
}

export function initials(name: string): string {
  return name
    .split(/\s+/)
    .map((w) => w.charAt(0))
    .join("")
    .slice(0, 2)
    .toUpperCase();
}

